var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43167 8.48837C4.34007 8.50428 4.25181 8.54884 4.17581 8.62509L1.1426 11.6583C0.953604 11.8473 0.953604 12.1529 1.1426 12.3419L4.17581 15.3751C4.47981 15.6801 5.00003 15.4633 5.00003 15.0333V13.0001H22C22.1325 13.002 22.2641 12.9775 22.3871 12.9281C22.51 12.8787 22.622 12.8053 22.7163 12.7123C22.8107 12.6192 22.8856 12.5083 22.9368 12.3861C22.9879 12.2638 23.0143 12.1326 23.0143 12.0001C23.0143 11.8676 22.9879 11.7364 22.9368 11.6141C22.8856 11.4918 22.8107 11.381 22.7163 11.2879C22.622 11.1949 22.51 11.1215 22.3871 11.0721C22.2641 11.0227 22.1325 10.9982 22 11.0001H5.00003V8.96689C5.00003 8.64364 4.70645 8.44066 4.43167 8.48837Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrowLeft);
export default __webpack_public_path__ + "static/media/long_arrow_left.33ec6d8fa110d485a27908a73fc7f84f.svg";
export { ForwardRef as ReactComponent };